// Region ekranu planowania przy otwarciu: z linku (?region_id=, np. z powiadomienia), inaczej zapamiętany
// wspólny wybór, gdy użytkownik ma ten region, inaczej pierwszy jego region. Planowanie wymaga jednego
// regionu — „wszystkie” z innych modułów daje pierwszy region, bez nadpisywania zapamiętanego wyboru.
import { regionDlaModulu } from '@ui'

export function regionStartowy({ zUrl, zapamietany, dostepne }: {
  zUrl: number | null
  zapamietany: number | null
  dostepne: number[]
}): number | null {
  if (zUrl != null) return zUrl
  return regionDlaModulu(zapamietany, dostepne, false)
}
